/**
* In this file contains all Socket client service - To communication with server side Socket
**/

import { io } from 'socket.io-client';

/*Declare the API BaseUrl*/
const APIURL=process.env.REACT_APP_SERVERURL;

/*Get access token from localStorage*/
var token = localStorage.getItem('token');

//Intial socketIO declaraction
var socketIO=io(APIURL, {
		  auth: { token: token }
	});

	/** 
	* This Function used To connect with Socket
	**/
	const connect=()=>{
		return socketIO=io(APIURL, {
		  auth: { token: localStorage.getItem('token') }
		});
	}
	
	/** 
	* This Function used To Disconnect Socket
	**/
	const disconnect=()=>{
		return socketIO.disconnect();
	}
	
	/** 
	* This function used To recieve call
	* @callback we get Object details like status and room
	   status contains boolean
	   room contains socket room name
	**/
	const receiveCall = (callback) => {
	   socketIO.off('recieve-call');
       socketIO.on('recieve-call', callback);
    };
	
	/** 
	* This function used To hold call
	* @callback we get boolean value
	**/
	const holdCall = (callback) => {
	   socketIO.off('hold-call');
       socketIO.on('hold-call', callback);
    };
	
	/**
	* This function used To Join call room
	* @data we pass Socket room name
	**/
	const joinCall=(data)=>{
		  socketIO.emit('join-call',data);
	};
	
	/**
	* This function used To Leave call room
	* @data we pass the Socket room name
	**/
	const leaveCall=(data)=>{
		  socketIO.emit('leave-call',data);
	};
	
	/**
	* This function used To close Incomingcall Modal after 30 sec of not response
	* @data we pass receiver,room keywords in Object format
	    receiver pass the receiver uuid
		room pass the Socket room name
	**/
	const closeIncomingCall=(data)=>{
		  socketIO.emit('end-call',data);
	};
	
	/** 
	* This function used To join Chat Room
	* @data pass parent id
	**/
	const joinChat=(data)=> {
		return socketIO.emit('join-chat',data);
	}
	
	/** 
	* This function used To send the message
	* @data we pass message,recipients,participants,content_type
	**/
   const sendMessage=(data)=>{
	   return socketIO.emit('send-message',data);
   }
   
   /**
   * This function used To get Chat Message
   * @callback we receive message,created_by,viewed_by,content_type,role,recipients, and participants in Object format
   **/
	const getMessage = (callback) => {
       socketIO.off('receive-message');
       socketIO.on('receive-message', callback);
    };
  
	/**
	* This function used To get unread Chat count
	* @callback we receive count and view keywords in Object format
	**/
	const getChatMsgCount = (callback) => {
		socketIO.off('message-count');
       socketIO.on('message-count', callback);
    };
	
	/**
	* This function used To leave Chat Room
	**/
	const leaveChat=()=>{
		socketIO.emit('leave-chat');
	};
	
	/** 
	* This function used To Trigger to get the online user
	**/
	const getOnlineUsersOnload=()=>{
		socketIO.emit('get-online-user');
	};
	
	/**
	* This function used To Get Online Users
	* @callback we receive online-user uuid in array format
	**/
   const getOnlineUsers=(callback)=>{
	  socketIO.off('online-user');
    socketIO.on('online-user', callback)
  };
  
  /** 
  * This function used To Get contact list user unread message count
  * @callback we receive count and id from the Object format
  **/
	const getContactChatCount = (callback) => {
		socketIO.off('chat-count');
       socketIO.on('chat-count', callback);
    };
	
	/**
	* this function used To listen the push notification
	* @callback we receive user and source keywords from Object format
	**/
	const listenPushNotification = (callback) => {
		socketIO.off('push-notification');
       socketIO.on('push-notification', callback);
    };
	
	/**
	* This function used To Get unread Notification counts
	* @callback we receive count keywords with the unread notification counts
 	**/
   const getNotificationCount=(callback)=>{
	  socketIO.off('notification');
    socketIO.on('notification', callback)
  };
  
  /**
  * This function used To delete the message form the receiver site instantly
  * @date pass the message recordid
  * @userId pass the receiver userId
  **/
   const deleteMessage=(data,userId)=>{
	   return socketIO.emit('delete-message',data,userId);
   }
   
   /** 
   * This function used To Get delete Notification recordid
   * @callback we receive the id
   **/
   const getDeleteMessageId=(callback)=>{
	  socketIO.off('get-delete-message');
    socketIO.on('get-delete-message', callback)
  };
	
	
const Socket={connect,disconnect,receiveCall,closeIncomingCall,joinChat,sendMessage,getMessage,getChatMsgCount,leaveChat,getOnlineUsers,holdCall,joinCall,leaveCall,getOnlineUsersOnload,getContactChatCount,listenPushNotification,getNotificationCount,deleteMessage,getDeleteMessageId};

export default Socket;